<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("vendor", 2) }}
      </div>
      <router-link class="btn-blue" to="vendors"
        >{{ $tc("vendor", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-3 align-self-center mb-2" v-if="false">
          <div class="d-flex align-items-center">
            <!-- <div class="dropdown-curve-container">
              <label
                :class="selectedCinema.length > 0 ? 'shift-up' : '' "
              >{{ $t('select') }} {{ $tc('cinema',2) }}</label>
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
                name="mapcinema"
                id="mapcinema"
              >
                <b-dropdown-item
                  v-for="(cinema, cinemaKey) in Cinemas"
                  :key="cinemaKey"
                  v-on:click="onSelectCinema(cinema.cine_id, cinema.cine_name)"
                >{{ cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>-->
            <multiselect
              v-model="cinemas"
              track-by="cine_id"
              label="cine_name"
              :options="Cinemas"
              placeholder="Select Cinemas"
              :multiple="true"
              :disabled="isRoleID"
              v-b-tooltip.hover
              :title="$t('vendorMapping_selectCinema')"
            >
              <span slot="noResult">
                No results found.
              </span>
            </multiselect>
            <!-- <Tooltip :title="$t('vendorMapping_selectCinema')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && cinemas.length == 0"
              >Please Select Cinema.</span
            >
          </p>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="vendor_details.v_name"
                name="vendorname"
                id="vendorname"
                v-validate="'required'"
                v-b-tooltip.hover
                :title="$t('vendorname_tooltip')"
              />
              <label>{{ $tc("vendor", 2) }} {{ $t("name") }}</label>
            </div>
            <!-- <Tooltip :title="$t('vendorname_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('vendorname')">{{
              errors.first("vendorname")
            }}</span>
          </p>
        </div>
        <div class="col-lg-6 col-xl-2 d-flex align-self-center mb-2">
          <b-form-checkbox
            v-model="vendor_details.v_is_active"
            class="j-checkbox"
            checked
          />
          <label>{{ $tc("vendor", 1) }} {{ $t("active") }}</label>
        </div>

        <div class="col-lg-6 col-xl-2 d-flex align-self-center px-0 mb-2">
          <b-form-checkbox v-model="rmv_is_active" class="j-checkbox" checked />
          <label class="mb-0">{{ $tc("vendor", 1) }} {{ $t("Mapping") }}</label>
        </div>

        <div class="col-lg-6 col-xl-2 d-flex align-self-center mb-2">
          <b-form-checkbox
            v-model="rmv_is_default_vendor"
            class="j-checkbox"
            checked
          />
          <label class="mb-0">{{ $t("Default") }} {{ $tc("vendor", 1) }}</label>
        </div>
      </form>

      <!--Contact Collapse-->
      <div class="section-wrapper col-12 px-0">
        <div class="d-flex">
          <div
            class="sectionName bor d-flex justify-content-between mb-2 col-12 align-items-center"
          >
            <div
              class="fs-17 font-weight-bold pl-2 align-items-center"
              @click="collapseObj.contactDetails = !collapseObj.contactDetails"
            >
              <div class="">{{ $t("contact") }} {{ $tc("details", 2) }}</div>
            </div>
            <span
              class="icon-collapse-up blue-icon mx-1 btn float-right"
              style="height: 30px;cursor:pointer;"
              v-if="collapseObj.contactDetails"
              @click="collapseObj.contactDetails = !collapseObj.contactDetails"
            ></span>
            <span
              class="icon-collapse blue-icon mx-1 btn float-right"
              style="height: 30px;cursor:pointer;"
              v-if="!collapseObj.contactDetails"
              @click="collapseObj.contactDetails = !collapseObj.contactDetails"
            ></span>
          </div>
        </div>
        <b-collapse
          v-model="collapseObj.contactDetails"
          class="pt-4 px-2 bor mb-4 back collapse show"
        >
          <section class="row">
            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="dropdown-curve-container">
                <label :class="selected.Country.length > 0 ? 'shift-up' : ''"
                  >{{ $t("select") }} {{ $tc("country", 2) }}</label
                >
                <div class="d-flex justify-content-center align-items-center">
                  <!-- <b-dropdown :text="selected.Country" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  href="#"
                  v-for="(country, countryIndex) in Countries"
                  :key="countryIndex"
                  v-on:click="onSelectHandler('country',country)"
                >{{ country.country_name }}</b-dropdown-item>
              </b-dropdown>-->
                  <multiselect
                    :options="Countries"
                    v-model="selected_country"
                    :searchable="true"
                    label="country_name"
                    track-by="country_name"
                    placeholder="Select Country"
                    @input="onSelectHandler('country', $event)"
                    :allowEmpty="false"
                    :showLabels="false"
                    v-b-tooltip.hover
                    :title="$t('vendorsCountry_tooltip')"
                  >
                    <span slot="noResult">
                      No results found.
                    </span>
                  </multiselect>
                  <!-- <Tooltip :title="$t('vendorsCountry_tooltip')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && selected.Country.length == 0"
                    >Please Select Country.</span
                  >
                </p>
              </div>
            </div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    type="text"
                    v-model="vendor_details.v_email"
                    name="vendoremail"
                    id="vendoremail"
                    v-validate="'required|email'"
                    v-b-tooltip.hover
                    :title="$t('vendorsEmailId_toolip')"
                  />
                  <label>{{ $t("primaryemailid") }}</label>
                </div>
                <!-- <Tooltip :title="$t('vendorsEmailId_toolip')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('vendoremail')">{{
                  errors.first("vendoremail")
                }}</span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    type="text"
                    v-model="vendor_details.v_extra_emails"
                    name="vendorextraemail"
                    id="vendorextraemail"
                    :title="$t('vendorsEmailId_toolip')"
                  />
                  <label>{{ $t("extraemailid") }}</label>
                </div>
                <!-- <Tooltip :title="$t('vendorsEmailId_toolip')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && extraEmailError">{{
                  "Please enter a valid email"
                }}</span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material row align-items-center">
                  <div class="col-4">
                    <b-dropdown
                      :text="
                        vendor_details.country_mob_code
                          ? vendor_details.country_mob_code
                          : 'Code'
                      "
                      variant="dropdown-curve"
                      class="w-100 text-center mr-3"
                      placeholder="code"
                      name="countrycode"
                      id="countrycode"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          type="search"
                          placeholder="Search Code"
                          class="form-control form-control-sm"
                          v-model="searchCode"
                        />
                      </div>
                      <b-dropdown-item
                        href="#"
                        v-for="(countrycode,
                        countryIndex) in countryCodeComputed"
                        :key="countryIndex"
                        v-on:click="onSelectHandler('countrycode', countrycode)"
                        v-if="countrycode.country_mob_code != null"
                        >{{ countrycode.country_mob_code }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <div class="col-7 pl-1">
                    <input
                      placeholder="."
                      type="text"
                      v-model="vendor_details.v_contact"
                      name="vendorno"
                      id="vendorno"
                      v-validate="'required|numeric|min:6|max:10'"
                      v-b-tooltip.hover
                      :title="$t('vendorsContactNumber_tooltip')"
                    />
                    <label>{{ $t("contactno") }}</label>
                  </div>

                  <div class="col-1">
                    <button
                      class="btn-transparent"
                      @click.prevent.stop="add_extra_contact()"
                    >
                      <img
                        src="@/assets/img/icons/plus.svg"
                        height="30"
                        width="30"
                      />
                    </button>
                  </div>
                </div>
                <!-- <Tooltip :title="$t('vendorsContactNumber_tooltip')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && !vendor_details.country_mob_code">{{
                  "Country Code is Required"
                }}</span>
                <span>{{ " " }}</span>
                <span v-if="submitted && errors.has('vendorno')">{{
                  errors.first("vendorno")
                }}</span>
              </p>
            </div>

            <div
              v-if="v_extra_contacts.length"
              v-for="(contact, contactIndex) in v_extra_contacts"
              :key="contactIndex"
              class="col-lg-6 col-xl-4 align-self-center mb-2"
            >
              <div class="d-flex align-items-center">
                <div class="input-material row align-items-center">
                  <div class="col-4">
                    <b-dropdown
                      :text="
                        contact.country_mob_code
                          ? contact.country_mob_code
                          : 'Code'
                      "
                      variant="dropdown-curve"
                      class="w-100 text-center mr-3"
                      placeholder="code"
                      :name="'countrycode' + contactIndex"
                      :id="'countrycode' + contactIndex"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          type="search"
                          placeholder="Search Code"
                          class="form-control form-control-sm"
                          v-model="searchCode"
                        />
                      </div>
                      <b-dropdown-item
                        href="#"
                        v-for="(countrycode,
                        countryIndex) in countryCodeComputed"
                        :key="countryIndex"
                        v-on:click="
                          contact.country_mob_code =
                            countrycode.country_mob_code
                        "
                        v-if="countrycode.country_mob_code != null"
                        >{{ countrycode.country_mob_code }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <div class="col-7 pl-1">
                    <input
                      placeholder="."
                      type="text"
                      v-model.number="contact.v_contact"
                      name="vendorno"
                      id="vendorno"
                      :title="$t('vendorsContactNumber_tooltip')"
                    />
                    <label>{{ $t("contactno") }}</label>
                  </div>

                  <div class="col-1">
                    <button
                      class="btn-transparent"
                      @click.prevent.stop="remove_extra_contact(contactIndex)"
                    >
                      <img
                        src="@/assets/img/icons/minus.svg"
                        height="30"
                        width="30"
                      />
                    </button>
                  </div>
                </div>
                <!-- <Tooltip :title="$t('vendorsContactNumber_tooltip')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && contact.error">{{
                  contact.error_message || "Contact Number is invalid"
                }}</span>
              </p>
            </div>

            <div v-if="v_extra_contacts.length" class="col-12"></div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    type="text"
                    v-model="vendor_details.v_address"
                    name="vendoraddress"
                    id="vendoraddress"
                    v-validate="'required'"
                    v-b-tooltip.hover
                    :title="$t('vendor_address')"
                  />
                  <label>{{ $t("address") }}</label>
                </div>
                <!-- <Tooltip :title="$t('vendor_address')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('vendoraddress')">{{
                  errors.first("vendoraddress")
                }}</span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    type="text"
                    v-model="vendor_details.v_location"
                    name="vendorlocation"
                    id="vendorlocation"
                    v-b-tooltip.hover
                    :title="$t('vendor_location')"
                  />
                  <label>{{ $t("location") }}</label>
                </div>
                <!-- <Tooltip :title="$t('vendor_location')" /> -->
              </div>
              <!-- <p class="error_message">{{ $t('blankfieldmsg') }}</p> -->
              <p class="error_message">
                <span></span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="dropdown-curve-container">
                <label :class="selected.State.length > 0 ? 'shift-up' : ''"
                  >{{ $t("select") }} {{ $tc("state", 1) }}</label
                >
                <div class="d-flex justify-content-center align-items-center">
                  <!-- <b-dropdown :text="selected.State" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(state,stateIndex) in States"
                  :key="stateIndex"
                  href="#"
                  @click="onSelectHandler('state',state)"
                >{{ state.state_name }}</b-dropdown-item>
              </b-dropdown>-->
                  <multiselect
                    :options="States"
                    v-model="selected_state"
                    :searchable="true"
                    label="state_name"
                    track-by="state_name"
                    placeholder="Select State"
                    :allowEmpty="false"
                    :showLabels="false"
                    @input="onSelectHandler('state', $event)"
                    v-b-tooltip.hover
                    :title="$t('vendorStates_tooltip')"
                  >
                    <span slot="noResult">
                      No results found.
                    </span></multiselect
                  >
                  <!-- <Tooltip :title="$t('vendorStates_tooltip')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && selected.State.length == 0"
                    >Please Select State.</span
                  >
                </p>
              </div>
            </div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="dropdown-curve-container">
                <label :class="selected.City.length > 0 ? 'shift-up' : ''"
                  >{{ $t("select") }} {{ $tc("city", 1) }}</label
                >
                <div class="d-flex justify-content-center align-items-center">
                  <!-- <b-dropdown :text="selected.City" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(city,cityIndex) in Cities"
                  :key="cityIndex"
                  href="#"
                  @click="onSelectHandler('city',city)"
                >{{ city.city_name }}</b-dropdown-item>
              </b-dropdown>-->
                  <multiselect
                    :options="Cities"
                    v-model="selected_city"
                    :searchable="true"
                    label="city_name"
                    track-by="city_name"
                    placeholder="Select City"
                    :allowEmpty="false"
                    :showLabels="false"
                    @input="onSelectHandler('city', $event)"
                    v-b-tooltip.hover
                    :title="$t('vendorCity_tooltip')"
                  >
                    <span slot="noResult">
                      No results found.
                    </span></multiselect
                  >
                  <!-- <Tooltip :title="$t('vendorCity_tooltip')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && selected.City.length == 0"
                    >Please Select City.</span
                  >
                </p>
              </div>
            </div>
          </section>
        </b-collapse>
      </div>
      <!--Contact Collapse End-->

      <!---Tax Collapse-->
      <div class="section-wrapper col-12 px-0">
        <div class="d-flex">
          <div
            class="sectionName bor d-flex justify-content-between mb-2 col-12 align-items-center"
          >
            <div
              class="fs-17 font-weight-bold pl-2 align-items-center"
              @click="collapseObj.taxDetails = !collapseObj.taxDetails"
            >
              <div class="">{{ $t("tax") }} {{ $tc("details", 2) }}</div>
            </div>
            <span
              class="icon-collapse-up blue-icon mx-1 btn float-right"
              style="height: 30px;cursor:pointer;"
              v-if="collapseObj.taxDetails"
              @click="collapseObj.taxDetails = !collapseObj.taxDetails"
            ></span>
            <span
              class="icon-collapse blue-icon mx-1 btn float-right"
              style="height: 30px;cursor:pointer;"
              v-if="!collapseObj.taxDetails"
              @click="collapseObj.taxDetails = !collapseObj.taxDetails"
            ></span>
          </div>
        </div>
        <b-collapse
          v-model="collapseObj.taxDetails"
          class="pt-4 px-2 bor mb-4 back collapse show"
        >
          <section class="row">
            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    class="text-right"
                    placeholder="."
                    type="text"
                    v-model="vendor_details.v_tin_number"
                    name="vendornumber"
                    id="vendornumber"
                    v-validate="'alpha_num|min:3|max:11'"
                    v-b-tooltip.hover
                    :title="$t('vendor_TinNumber')"
                  />
                  <label>{{ $tc("vendor", 2) }} {{ $t("tinnumber") }}</label>
                </div>
                <!-- <Tooltip :title="$t('vendor_TinNumber')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('vendornumber')">{{
                  errors.first("vendornumber")
                }}</span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    class="text-right"
                    placeholder="."
                    type="text"
                    v-model="vendor_details.v_tax_number"
                    name="vendortax"
                    id="vendortax"
                    v-validate="'alpha_num|min:3|max:15'"
                    v-b-tooltip.hover
                    :title="$t('vendor_TaxNumber')"
                  />
                  <label>{{ $tc("vendor", 2) }} {{ $t("taxnumber") }}</label>
                </div>
                <!-- <Tooltip :title="$t('vendor_TaxNumber')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('vendortax')">{{
                  errors.first("vendortax")
                }}</span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    class="text-right"
                    placeholder="."
                    type="text"
                    v-model="vendor_details.v_tax_type"
                    name="taxtype"
                    id="taxtype"
                    v-validate="'regex:[A-Za-z0-9 ]'"
                    v-b-tooltip.hover
                    :title="$t('vendor_TaxType')"
                  />
                  <label>{{ $tc("vendor", 2) }} {{ $t("taxtype") }}</label>
                </div>
                <!-- <Tooltip :title="$t('vendor_TaxType')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('taxtype')">{{
                  errors.first("taxtype")
                }}</span>
              </p>
            </div>
          </section>
        </b-collapse>
      </div>

      <!---Tax Collapse Ends-->

      <!---Vendor Rate-->
      <div class="section-wrapper col-12 px-0">
        <div class="d-flex">
          <div
            class="sectionName bor d-flex justify-content-between mb-2 col-12 align-items-center"
          >
            <div
              class="fs-17 font-weight-bold pl-2 align-items-center"
              @click="collapseObj.taxDetails = !collapseObj.taxDetails"
            >
              <div class="">{{ $tc("vendor", 1) }} {{ $t("rate") }}</div>
            </div>
            <span
              class="icon-collapse-up blue-icon mx-1 btn float-right"
              style="height: 30px;cursor:pointer;"
              v-if="collapseObj.taxDetails"
              @click="collapseObj.taxDetails = !collapseObj.taxDetails"
            ></span>
            <span
              class="icon-collapse blue-icon mx-1 btn float-right"
              style="height: 30px;cursor:pointer;"
              v-if="!collapseObj.taxDetails"
              @click="collapseObj.taxDetails = !collapseObj.taxDetails"
            ></span>
          </div>
        </div>
        <b-collapse
          v-model="collapseObj.taxDetails"
          class="pt-4 px-2 bor mb-4 back collapse show"
        >
          <section class="row">
            <div
              class="table-scroll w-100 mx-3 mb-3"
              v-if="finalAddVendorMappingArray.length > 0"
            >
              <label class="font-weight-bold">Add Review</label>
              <table class="swc-report-table" border="1">
                <thead>
                  <tr>
                    <th class="bg-lightgrey p-1">Cinema</th>
                    <th class="bg-lightgrey p-1">Raw Material</th>
                    <th class="bg-lightgrey p-1">QTY</th>
                    <th class="bg-lightgrey p-1">UOM</th>
                    <th class="bg-lightgrey p-1">Rate</th>
                    <th class="bg-lightgrey p-1">Tax %</th>
                    <th class="bg-lightgrey p-1">Total</th>
                    <th class="bg-lightgrey p-1">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(list, listKey) in finalAddVendorMappingArray"
                    :key="listKey"
                  >
                    <td class="text-left">{{ list.cinema_name || "-" }}</td>
                    <td class="text-left">{{ list.name || "-" }}</td>
                    <td class="text-right">{{ list.vr_qty || "0" }}</td>
                    <td class="text-left">{{ list.uom_unit || "-" }}</td>
                    <td class="text-right">{{
                      parseFloat(list.vr_rate).toFixed(4)
                    }}</td>
                    <td class="text-right">{{
                      parseFloat(list.vr_tax_amount_percentage).toFixed(4)
                    }}</td>
                    <td class="text-right">{{
                      parseFloat(list.vr_total_amount).toFixed(4)
                    }}</td>
                    <td>
                      <div
                        class="icon-sm-minus blue-icon ml-2 btn"
                        @click="
                          onRemoveFinalVendorPricing(list, listKey, 'Add')
                        "
                      ></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-12">
              <div class="text-center mb-3">
                <button
                  class="btn-transparent"
                  @click="onClickAddVendorMapping"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </div>
          </section>
        </b-collapse>
      </div>

      <!---Vendor Rate End-->

      <!-- FOR RAW MATERIALS FROM VENDOR MAPPING -->

      <div class="col-md-12 text-center mt-4">
        <button
          :disabled="btenable"
          @click.prevent.stop="onFinalSubmit(false)"
          class="btn-blue"
        >
          {{ $t("save") }}
        </button>
        <button
          :disabled="btenable"
          @click.prevent.stop="onFinalSubmit(true)"
          class="btn-blue"
        >
          {{ $t("saveaddmore") }}
        </button>
        <button @click.prevent.stop="onResetForm()" class="btn-black">
          {{ $t("reset") }}
        </button>
        <b-button class="btn-outline-grey" variant="default" to="vendors">{{
          $t("cancel")
        }}</b-button>
      </div>
    </div>
    <b-modal
      id="AddVendorMapping"
      ref="AddVendorMapping"
      :title="'Add Vendor Price'"
      hide-footer
      size="lg"
      show
    >
      <div class="">
        <section
          class="row"
          :style="'zoom: 0.9;max-height:520px;overflow-y:auto;'"
        >
          <div
            v-for="(list, listKey) in newVendorRateMapping"
            :key="listKey"
            class="col-md-12"
          >
            <div class="row mb-3 mx-2">
              <div class="col-md-11 inner-vendor-rate">
                <div class="row pt-3">
                  <div class="col-md-6 mb-3">
                    <multiselect
                      :options="Cinemas"
                      v-model="list.selectedCinema"
                      :searchable="true"
                      label="cine_name"
                      track-by="cine_id"
                      placeholder="Select Cinemas"
                      :multiple="true"
                    ></multiselect>
                  </div>

                  <div class="col-md-6 mb-3">
                    <multiselect
                      :options="RawMaterials"
                      v-model="list.selectedRawMaterial"
                      :searchable="true"
                      @select="onSelectRawMaterial($event, listKey, 'Add')"
                      label="rm_name"
                      track-by="rm_id"
                      placeholder="Select Raw Material"
                      :allowEmpty="false"
                      :showLabels="false"
                    ></multiselect>
                  </div>

                  <div class="col-md-3 mb-3">
                    <div class="input-material">
                      <input
                        v-model="list.vr_qty"
                        type="number"
                        name="mapquantity"
                        id="mapquantity"
                        placeholder="."
                      />
                      <label>{{ $t("quantity") }}</label>
                    </div>
                  </div>

                  <div class="col-md-3 mb-3">
                    <div class="dropdown-curve-container">
                      <label :class="list.uom_unit.length > 0 ? 'shift-up' : ''"
                        >UOM</label
                      >
                      <b-dropdown
                        :text="list.uom_unit"
                        :disabled="DISABLE_RAW_MATERIAL_UOM_SWITCH == 'Y'"
                        variant="dropdown-curve"
                        class="w-100"
                      >
                        <b-dropdown-item
                          v-for="(uom, uomKey) in list.uom_units"
                          :key="uomKey"
                          v-on:click="onSelectUnitOfM(uom, listKey, 'Add')"
                          >{{ uom.uom_unit }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                  </div>

                  <div class="col-md-3 mb-3">
                    <div class="input-material">
                      <input
                        v-model="list.vr_rate"
                        type="number"
                        v-on:keyup="onChangeRate($event, listKey, 'Add')"
                        name="rate"
                        id="rate"
                        placeholder="."
                      />
                      <label>{{ $t("rate") }}</label>
                    </div>
                  </div>
                  <div class="col-md-3 mb-3">
                    <div class="input-material">
                      <input
                        v-model="list.vr_tax_amount_percentage"
                        type="number"
                        v-on:keyup="
                          onChangeTaxPercentage($event, listKey, 'Add')
                        "
                        name="tax"
                        id="tax"
                        placeholder="."
                      />
                      <label>{{ $t("Tax In %") }}</label>
                    </div>
                  </div>

                  <div class="col-md-3 mb-3">
                    <div class="input-material">
                      <input
                        v-model="list.vr_tax_amount"
                        type="number"
                        v-on:keyup="onChangeTax($event, listKey, 'Add')"
                        name="tax"
                        id="tax"
                        disabled
                        placeholder="."
                      />
                      <label>{{ $t("Tax Amount") }}</label>
                    </div>
                  </div>

                  <div class="col-md-3 mb-3">
                    <div class="input-material">
                      <input
                        v-model="list.vr_total_amount"
                        type="number"
                        name="Total Amount"
                        id="Total Amount"
                        disabled
                        placeholder="."
                        v-validate="'required|decimal'"
                      />
                      <label>{{ $t("totalamount") }}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-1 d-flex justify-content-center mb-2">
                <button
                  class="btn-transparent"
                  v-if="listKey === 0 && false"
                  @click.prevent.stop="increaseRow_add_vm()"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="35"
                    width="35"
                  />
                </button>
                <button
                  :disabled="listKey === 0"
                  @click.prevent.stop="decreaseRow_remove_vm(listKey)"
                  class="btn-transparent"
                >
                  <img
                    src="@/assets/img/icons/minus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex justify-content-center mb-2">
              <div class="d-flex justify-content-center mb-2">
                <button
                  class="btn-transparent"
                  @click.prevent.stop="increaseRow_add_vm()"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </div>
          </div>

          <div class="col-12" v-if="submitted && isValidationError">
            <p class="error_message fs-14">
              <span v-if="submitted && isValidationError">{{
                $t("please_enter_all_details")
              }}</span>
            </p>
          </div>
        </section>
        <div class="col-md-12 text-center mt-4">
          <button
            @click.prevent.stop="onSaveAddNewVendorMapping()"
            class="btn-blue"
          >
            {{ $t("Save") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            @click="onClickCancelAddVedorMapping()"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import PosFnbService from "@/services/PosFnbService";
  import Multiselect from "vue-multiselect";

  const selected = {};
  export default {
    components: { Multiselect },
    data() {
      return {
        finalAddVendorMappingArray: [],
        newVendorRateMapping: [],
        newObj: {
          cinema_id: null,
          selectedCinema: [],
          cinemaIds: [],
          name: "",
          rm_id: "",
          vr_qty: "",
          uom_id: "",
          uom_unit: "",
          vr_rate: null,
          selectedRawMaterial: "",
          vr_tax_amount: 0,
          vr_tax_amount_percentage: 0,
          vr_total_amount: null,
          vr_is_active: true,
          uom_units: [],
        },
        v_extra_contacts: [],
        collapseObj: {
          contactDetails: true,
          taxDetails: true,
          vendorRate: true,
        },
        selected_country: null,
        selected_state: null,
        selected_city: null,
        btenable: false,
        submitted: false,
        cinemas: [],
        selected: null,
        options: ["Kg", "Gms", "Lt", "Pks", "Ps"],
        vendor_details: {
          v_name: "",
          v_tin_number: "",
          v_tax_number: "",
          v_tax_type: "",
          v_address: "",
          city_id: null,
          state_id: null,
          country_id: null,
          country_mob_code: "",
          v_contact: "",
          v_email: "",
          v_extra_emails: "",
          v_location: "",
          v_is_active: true,
        },
        extraEmailError: false,
        //VendorMapping
        Cinemas: [],
        isRoleID: "",
        selectedCinema: "",
        selectedRawMaterials: [
          {
            name: "",
            rm_id: null,
            vr_qty: "",
            uom_id: null,
            uom_unit: "",
            vr_rate: "",
            vr_tax_amount: 0,
            vr_tax_amount_percentage: 0,
            vr_total_amount: "",
            vr_is_active: true,
            uom_units: [],
          },
        ],
        selectedRawMaterial: "",
        cinema_id: "",
        UomList: [],
        RawMaterials: [],
        RawMaterialsCopy: [],
        rmv_is_active: true,
        rmv_is_default_vendor: true,
        //ENDS
        searchRawMaterial: "",

        Countries: [],
        States: [],
        Cities: [],
        selected: {
          Country: "",
          State: "",
          City: "",
        },
        searchCode: "",
        CodeListCopy: [],
        countryList: [],
        SelectedCountryCode: "",
        isValidationError: false,
      };
    },
    computed: {
      DISABLE_RAW_MATERIAL_UOM_SWITCH() {
        return this.$store.getters.DISABLE_RAW_MATERIAL_UOM_SWITCH || 'N';
      },
      countryCodeComputed() {
        let search = String(this.searchCode || "");
        let countryList = this.CodeListCopy;

        if (search.length) {
          countryList = this.CodeListCopy.filter((x) => {
            if (
              x.country_mob_code &&
              x.country_mob_code
                .toLowerCase()
                .includes(String(search).toLowerCase())
            ) {
              return x;
            }
          });
        }

        return countryList;
      },
    },
    mounted() {
      this.getCountriesList();
      this.getRawMaterials();
      // this.getUoM();
    },
    beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      this.getCinemasList(obj);
    },
    methods: {
      VendorMappingValidation: function(arr = [], showErrorMsg = true) {
        let count = 0;
        let ErrorMsg = ``;
        let ErrorIndex = null;
        if (arr.length > 0) {
          arr.map((x, index) => {
            if (!x.rm_id || x.rm_id == null) {
              count++;
              (ErrorMsg = `Please Select Raw Material`), (ErrorIndex = index);
            } else if (x.uom_id == null || !x.uom_id) {
              count++;
              (ErrorMsg = `Please Select Unit Of Measurement`),
                (ErrorIndex = index);
            } else if (!x.cinema_id || x.cinema_id == null) {
              count++;
              (ErrorMsg = `Please Select Cinema`), (ErrorIndex = index);
            }
          });
        }

        if (count > 0) {
          if (showErrorMsg) {
            this.$toasted.show(ErrorMsg);
          }
          return false;
        } else {
          return true;
        }
      },
      onSaveAddNewVendorMapping() {
        console.log("this.newVendorRateMapping", this.newVendorRateMapping);
        let tempArray = [];
        this.newVendorRateMapping.forEach((x) => {
          x.selectedCinema.forEach((y) => {
            let newObj = {
              ...x,
              cinema_id: y.cine_id,
              cinema_name: y.cine_name,
            };
            tempArray.push(newObj);
          });
        });
        if (this.VendorMappingValidation(tempArray)) {
          this.finalAddVendorMappingArray = this.finalAddVendorMappingArray.concat(
            tempArray
          );
          this.newVendorRateMapping = [];
          this.$bvModal.hide("AddVendorMapping");
          console.log(
            "this.finalAddVendorMappingArray",
            this.finalAddVendorMappingArray
          );
        } else {
          console.log("COMING IN ELSE");
        }
      },
      onRemoveFinalVendorPricing(vm, vmIndex, type) {
        if (type == "Add") {
          this.finalAddVendorMappingArray.splice(vmIndex, 1);
        } else {
          this.finalEditVendorMappingArray.splice(vmIndex, 1);
        }
      },
      onClickCancelAddVedorMapping() {
        this.newVendorRateMapping = [];
        this.$bvModal.hide("AddVendorMapping");
      },
      decreaseRow_remove_vm: function(index) {
        this.newVendorRateMapping.splice(index, 1);
        this.isValidationError = false;
      },
      increaseRow_add_vm() {
        this.newVendorRateMapping.push({
          cinema_id: null,
          selectedCinema: [],
          cinemaIds: [],
          name: "",
          rm_id: "",
          vr_qty: "",
          uom_id: "",
          uom_unit: "",
          vr_rate: null,
          selectedRawMaterial: "",
          vr_tax_amount: 0,
          vr_tax_amount_percentage: 0,
          vr_total_amount: null,
          vr_is_active: true,
          uom_units: [],
        });
      },
      onClickAddVendorMapping() {
        this.newVendorRateMapping = [];
        let newObj = {
          cinema_id: null,
          selectedCinema: [],
          cinemaIds: [],
          name: "",
          rm_id: "",
          vr_qty: "",
          uom_id: "",
          uom_unit: "",
          vr_rate: null,
          selectedRawMaterial: "",
          vr_tax_amount: 0,
          vr_tax_amount_percentage: 0,
          vr_total_amount: null,
          vr_is_active: true,
          uom_units: [],
        };
        if (this.newVendorRateMapping.length == 0) {
          this.newVendorRateMapping.push(newObj);
        }
        this.$bvModal.show("AddVendorMapping");
      },
      add_extra_contact() {
        let extra_contact = {
          country_mob_code: "",
          v_contact: "",
          error: false,
          error_message: "",
        };
        this.v_extra_contacts.push(extra_contact);
      },
      remove_extra_contact(index) {
        if (
          index == null ||
          index == undefined ||
          this.v_extra_contacts.length <= 0
        )
          return;

        this.v_extra_contacts = this.v_extra_contacts.filter(
          (_, i) => i != index
        );
      },
      onSearchRawMaterial: function(value) {
        if (this.searchRawMaterial && this.searchRawMaterial.length > 0) {
          this.RawMaterials = this.RawMaterialsCopy.filter((x) => {
            if (
              x.rm_name
                .toLowerCase()
                .includes(this.searchRawMaterial.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.RawMaterials = this.RawMaterialsCopy;
        }
      },
      //Vendor Mapping Functions
      increaseRow: function() {
        this.selectedRawMaterials.push({
          name: "",
          rm_id: "",
          vr_qty: "",
          uom_id: "",
          uom_unit: "",
          vr_rate: null,
          vr_tax_amount: 0,
          vr_tax_amount_percentage: 0,
          vr_total_amount: null,
          vr_is_active: true,
          uom_units: [],
        });
      },
      decreaseRow: function(index) {
        this.selectedRawMaterials.splice(index, 1);
        this.isValidationError = false;
      },
      getCinemasList: function(cine_id) {
        // let payload = {
        //   tableName: "ms_cinemas",
        //   cine_is_active: "Y"
        // };
        MasterService.GetCinemas({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  // this.selectedCinema = x.cine_name;
                  // this.onSelectCinema(x.cine_id, x.cine_name);
                  this.cinemas.push(x);
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      getRawMaterials: function() {
        let payload = {
          tableName: "ms_raw_materials",
          rm_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.RawMaterials = data.Records;
              this.RawMaterialsCopy = data.Records;
            } else {
              // this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      // getUoM: function() {
      //   let payload = {
      //     tableName: "ms_unit_of_measurement",
      //     uom_is_active: "Y"
      //   };
      //   MasterService.GetActiveList(payload)
      //     .then(response => {
      //       const { data } = response;
      //       if (data && data.status && data.Records.length > 0) {
      //         this.UomList = data.Records;
      //       } else {
      //         this.$toasted.show(data.message);
      //       }
      //     })
      //     .catch(error => {
      //       this.$toasted.show(error);
      //     });
      // },
      onSelectRawMaterial: function(params, index, type) {
        if (type == "Add") {
          this.newVendorRateMapping[index].name = params.rm_name;
          this.newVendorRateMapping[index].rm_id = params.rm_id;
          this.newVendorRateMapping[index].uom_id = "";
          this.newVendorRateMapping[index].uom_unit = "";
          this.getRelatedUom(index, params.rm_id, params, "Add");
          this.isValidationError = false;
        } else {
          this.selectedRawMaterials[index].name = params.rm_name;
          this.selectedRawMaterials[index].rm_id = params.rm_id;
          this.selectedRawMaterials[index].uom_id = "";
          this.selectedRawMaterials[index].uom_unit = "";
          this.getRelatedUom(index, params.rm_id, params);
          this.isValidationError = false;
        }
      },
      getRelatedUom: function(index, rm_id, rmObj,  type) {
        PosFnbService.getUomFromRawMaterial({ rm_id })
          .then((response) => {
            const { data } = response;
            if (data.status) {
              let filteredUOMs = data.Records.filter((x) => x.uom_id == rmObj.uom_id_threshold);
              let selectedUOM = null;
              if(filteredUOMs && filteredUOMs.length) {
                selectedUOM = filteredUOMs[0];
              } else {
                selectedUOM = data.Records[0];
              }
              if (type == "Add") {
                this.newVendorRateMapping[index].uom_id = selectedUOM['uom_id'];
                this.newVendorRateMapping[index].uom_unit = selectedUOM['uom_unit'];
                this.newVendorRateMapping[index].uom_units = data.Records;
              } else {
                this.selectedRawMaterials[index].uom_id = selectedUOM['uom_id'];
                this.selectedRawMaterials[index].uom_unit = selectedUOM['uom_unit'];
                this.selectedRawMaterials[index].uom_units = data.Records;
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      onSelectUnitOfM: function(params, index, type) {
        if (type == "Add") {
          this.newVendorRateMapping[index].uom_id = params.uom_id;
          this.newVendorRateMapping[index].uom_unit = params.uom_unit;
          this.isValidationError = false;
        } else {
          this.selectedRawMaterials[index].uom_id = params.uom_id;
          this.selectedRawMaterials[index].uom_unit = params.uom_unit;
          this.isValidationError = false;
        }
      },
      onSelectCinema: function(cine_id, cine_name) {
        this.selectedCinema = cine_name;
        this.cinema_id = cine_id;
      },
      onChangeRate: function(e, index, type) {
        if (type == "Add") {
          this.newVendorRateMapping[index].vr_total_amount =
            this.newVendorRateMapping[index].vr_total_amount != ""
              ? this.newVendorRateMapping[index].vr_total_amount
              : 0;
          ``;

          this.newVendorRateMapping[index].vr_tax_amount =
            parseFloat(
              this.newVendorRateMapping[index].vr_tax_amount_percentage *
                e.target.value
            ) / 100;

          this.newVendorRateMapping[index].vr_total_amount =
            parseFloat(e.target.value) +
            parseFloat(this.newVendorRateMapping[index].vr_tax_amount || 0);
        } else {
          this.selectedRawMaterials[index].vr_total_amount =
            this.selectedRawMaterials[index].vr_total_amount != ""
              ? this.selectedRawMaterials[index].vr_total_amount
              : 0;

          this.selectedRawMaterials[index].vr_tax_amount =
            parseFloat(
              this.selectedRawMaterials[index].vr_tax_amount_percentage *
                e.target.value
            ) / 100;

          this.selectedRawMaterials[index].vr_total_amount =
            parseFloat(e.target.value) +
            parseFloat(this.selectedRawMaterials[index].vr_tax_amount || 0);
        }
      },
      onChangeTaxPercentage: function(e, index, type) {
        if (type == "Add") {
          this.newVendorRateMapping[index].vr_rate =
            this.newVendorRateMapping[index].vr_rate != ""
              ? this.newVendorRateMapping[index].vr_rate
              : 0;

          this.newVendorRateMapping[index].vr_tax_amount =
            parseFloat(
              this.newVendorRateMapping[index].vr_rate * e.target.value
            ) / 100;

          this.newVendorRateMapping[index].vr_total_amount =
            parseFloat(this.newVendorRateMapping[index].vr_tax_amount) +
            parseFloat(this.newVendorRateMapping[index].vr_rate);
        } else {
          this.selectedRawMaterials[index].vr_rate =
            this.selectedRawMaterials[index].vr_rate != ""
              ? this.selectedRawMaterials[index].vr_rate
              : 0;

          this.selectedRawMaterials[index].vr_tax_amount =
            parseFloat(
              this.selectedRawMaterials[index].vr_rate * e.target.value
            ) / 100;

          this.selectedRawMaterials[index].vr_total_amount =
            parseFloat(this.selectedRawMaterials[index].vr_tax_amount) +
            parseFloat(this.selectedRawMaterials[index].vr_rate);
        }
      },
      onChangeTax: function(e, index, type) {
        if (type == "Add") {
          this.newVendorRateMapping[index].vr_rate =
            this.newVendorRateMapping[index].vr_rate != ""
              ? this.newVendorRateMapping[index].vr_rate
              : 0;
          this.newVendorRateMapping[index].vr_total_amount =
            parseFloat(e.target.value) +
            parseFloat(this.newVendorRateMapping[index].vr_rate);
        } else {
          this.selectedRawMaterials[index].vr_rate =
            this.selectedRawMaterials[index].vr_rate != ""
              ? this.selectedRawMaterials[index].vr_rate
              : 0;
          this.selectedRawMaterials[index].vr_total_amount =
            parseFloat(e.target.value) +
            parseFloat(this.selectedRawMaterials[index].vr_rate);
        }
      },
      //Vedor mapping functions ends
      onSelectHandler: function(type, value) {
        if (type == "country") {
          this.selected.Country = value.country_name;
          this.vendor_details.country_id = value.country_id;
          this.selected_state = null;
          this.selected_city = null;
          this.vendor_details.country_mob_code = value.country_mob_code;
          this.getStatesList(value.country_id);
        } else if (type == "state") {
          this.selected.State = value.state_name;
          this.vendor_details.state_id = value.state_id;
          this.selected_city = null;

          this.getCitiesList(value.state_id);
        } else if (type == "city") {
          this.selected.City = value.city_name;
          this.vendor_details.city_id = value.city_id;
        } else if (type == "countrycode") {
          this.vendor_details.country_mob_code = value.country_mob_code;
        }
      },
      onSearchCode() {
        if (this.searchCode && this.searchCode.length > 0) {
          this.countryList = this.CodeListCopy.filter((x) => {
            if (
              x.country_mob_code &&
              x.country_mob_code
                .toLowerCase()
                .includes(this.searchCode.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.countryList = this.CodeListCopy;
        }
      },
      getCountriesList: function() {
        this.Countries = [];
        let payload = {
          tableName: "ms_countries",
          country_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              data.Records.forEach((record) => {
                delete record.created_at;
                delete record.created_by;
                delete record.updated_at;
                delete record.updated_by;
                delete record.country_is_active;
                delete record.iso_2;
                delete record.iso_3;
                delete record.country_code;
              });

              this.Countries = data.Records;
              this.countryList = data.Records;
              this.CodeListCopy = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getStatesList: function(country_id) {
        let payload = {
          tableName: "ms_states",
          state_is_active: "Y",
          country_id: country_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.States = data.Records;
              this.Cities = [];
            } else {
              // Show Errors
              this.States = [];
              this.Cities = [];

              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getCitiesList: function(state_id) {
        this.Cities = [];
        let payload = {
          tableName: "ms_cities",
          city_is_active: "Y",
          state_id: state_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Cities = data.Records;
            } else {
              // Show Errors
              this.Cities = [];

              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },

      onResetForm: function() {
        this.extraEmailError = false;
        this.v_extra_contacts = [];
        this.cinemas = [];
        this.selected = {
          Country: "",
          State: "",
          City: "",
        };
        this.selectedRawMaterials = [
          {
            name: "",
            rm_id: "",
            vr_qty: "",
            uom_id: "",
            uom_unit: "",
            vr_rate: "",
            vr_is_active: true,
          },
        ];
        this.selectedRawMaterial = "";
        this.vendor_details = {
          v_name: "",
          v_tin_number: "",
          v_tax_number: "",
          v_tax_type: "",
          v_address: "",
          city_id: "",
          state_id: "",
          country_id: "",
          v_contact: "",
          v_email: "",
          v_extra_emails: "",
          v_location: "",
          v_is_active: true,
          country_mob_code: "",
        };
      },
      VendorRateValidation: function() {
        let count = 0;

        this.selectedRawMaterials.map((x) => {
          if (x.rm_id == null || x.uom_id == null || !x.rm_id || !x.uom_id) {
            count++;
          }
        });

        if (count > 0) {
          return true;
        } else {
          return false;
        }
      },
      onFinalSubmit: function(flag) {
        this.extraEmailError = false;
        this.v_extra_contacts.forEach((x) => {
          x.error = false;
          x.error_message = "";
        });

        this.submitted = true;
        this.isValidationError = false;
        let checkRawMaterialExist = true;
        if (this.VendorRateValidation()) {
          console.log("here true");
          checkRawMaterialExist = true;

          // this.isValidationError = true;

          // return;
        } else {
          checkRawMaterialExist = true;

          console.log("here false");
          this.isValidationError = false;
        }

        if (
          this.vendor_details.v_extra_emails &&
          this.vendor_details.v_extra_emails.length > 0
        ) {
          let validEmail = true;

          let emails = [
            ...new Set(
              this.vendor_details.v_extra_emails
                .replace(/\s/g, "")
                .split(",")
                .map((x) => x.trim())
                .filter((x) => !!x)
            ),
          ];

          const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

          for (let i = 0; i < emails.length; i++) {
            if (emails[i] == "" || !regex.test(emails[i])) {
              validEmail = false;
            }
          }

          if (validEmail) {
            this.vendor_details.v_extra_emails = emails.join(",");
          } else {
            this.extraEmailError = true;
            return;
          }
        }

        if (this.v_extra_contacts && this.v_extra_contacts.length) {
          let validContact = true;
          this.v_extra_contacts.forEach((c) => {
            if (!c.country_mob_code || !c.v_contact) {
              c.error = true;
              validContact = false;
            }
            if (!c.country_mob_code) {
              c.error_message = `${c.error_message} Country Code is Required`;
            }
            if (!c.v_contact) {
              c.error_message = `${c.error_message} Please enter Contact Number`;
            } else if (c.v_contact.length <= 5) {
              c.error = true;
              validContact = false;
              c.error_message = `${c.error_message} Please enter minimum 6 characters`;
            }
          });

          if (validContact) {
            this.vendor_details.v_extra_contact = this.v_extra_contacts
              .map((x) => {
                return `${String(x.country_mob_code).trim()}-${String(
                  x.v_contact
                ).trim()}`;
              })
              .join(",");
          } else {
            return;
          }
        } else if (
          this.v_extra_contacts.length &&
          this.v_extra_contacts.length === 0
        ) {
          this.vendor_details.v_extra_contact = "";
        }

        this.$validator.validate().then((valid) => {
          console.log(valid);
          if (
            this.vendor_details.country_id == null ||
            this.vendor_details.state_id == null ||
            this.vendor_details.city_id == null ||
            !this.vendor_details.country_mob_code
          ) {
            return;
          }
          if (valid) {
            let loader = this.$loading.show();

            this.btenable = true;
            let payload = {
              ...this.vendor_details,
            };
            PosFnbService.AddVendor(payload)
              .then((response) => {
                this.btenable = false;
                const { data } = response;
                if (data && data.status) {
                  let vendor_id = data.insertId;
                  loader.hide();
                  if (checkRawMaterialExist) {
                    this.onSubmitVendorMapping(vendor_id, flag);
                  } else {
                    this.$toasted.show("Vendor Added Successfully");
                    this.$router.push({
                      path: "vendors",
                    });
                  }

                  this.submitted = false;
                  this.isValidationError = false;
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError); //message
          }
        });
      },
      onSubmitVendorMapping(vendor_id, flag) {
        console.log(this.cinemas);
        this.btenable = true;
        let payload = {
          // cinema_id: this.cinema_id,
          cinemas: this.cinemas,
          vendor_id: vendor_id,
          rmv_is_default_vendor: this.rmv_is_default_vendor == true ? "Y" : "N",
          rmv_is_active: this.rmv_is_active == true ? "Y" : "N",
          selectedRawMaterials: this.selectedRawMaterials,
          finalAddVendorMappingArray: this.finalAddVendorMappingArray,
        };
        PosFnbService.AddVendorMapping(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            if (data && data.status) {
              // this.$router.push({
              //   path: "vendor-mapping"
              // });
              if (flag) {
                this.$toasted.show(data.message);
                this.$validator.reset();
                this.onResetForm();
                //TODO Reset Form
              } else {
                this.$router.push({
                  path: "vendors",
                });
              }
              // this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
    },
  };
</script>

<style>
  .sectionName {
    padding: 5px 0px;
    color: var(--blue);
  }
  .sectionName .fs-17 {
    font-size: 17px !important;
  }
  .text-small-instruction {
    font-weight: 400;
  }
  .text-red {
    color: red;
  }

  .disable-field {
    cursor: not-allowed;
    opacity: 0.5;
  }
  .bor {
    border: 1px solid #b1b4b8;
    border-radius: 10px;
  }
  .back {
    background-color: #fff;
  }
  .inner-vendor-rate {
    background-color: #fff;
    border: 1px solid #b1b4b8;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/VendorsComponents/addVendor.vue